import React from 'react';

const HeaderDivider = () => {
    return (
        <div
            style={{
                background: 'linear-gradient(90deg, #1f477c 0%, #072955 100%)',
                width: '100%',
                height: '20px',
            }}
        >
            {' '}
        </div>
    );
};

export default HeaderDivider;
